import { ComputeReservationDurationConfiguration, ReservationActionTypesEnum } from '@api/ringil-api.v2';

export const shouldDoubleDuration = (
  settings: ComputeReservationDurationConfiguration | undefined,
  actionTypes: ReservationActionTypesEnum[] | undefined,
): boolean =>
  settings?.doubleLoadingUnloadingTime === true &&
  actionTypes?.includes(ReservationActionTypesEnum.LOADING) === true &&
  actionTypes?.includes(ReservationActionTypesEnum.UNLOADING) === true;